// extracted by mini-css-extract-plugin
export default {"cent":"BetSpinner_cent__7pJPg","rotate":"BetSpinner_rotate__UpuRy","rotation":"BetSpinner_rotation__vJYyA"};